import { render } from "./notify-box.component.vue?vue&type=template&id=7a785df2&scoped=true&ts=true"
import script from "./notify-box.component.vue?vue&type=script&lang=ts"
export * from "./notify-box.component.vue?vue&type=script&lang=ts"

import "./notify-box.component.vue?vue&type=style&index=0&id=7a785df2&lang=scss&scoped=true"

import exportComponent from "/agent/_work/1/s/Customer/onlinekiosk_vue_js/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a785df2"]])

export default __exports__